import { render, staticRenderFns } from "./StyleSwiper.vue?vue&type=template&id=0ab7f8c0&scoped=true&"
import script from "./StyleSwiper.vue?vue&type=script&lang=ts&"
export * from "./StyleSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./StyleSwiper.vue?vue&type=style&index=0&id=0ab7f8c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab7f8c0",
  null
  
)

export default component.exports